const state = {
  taskId: '',
  businessKey: '',
  taskDefinitionKey: ''
}

const mutations = {
  OPEN_APPROVAL: (state, flowInfo) => {
    state.taskId = flowInfo.taskId
    state.businessKey = flowInfo.businessKey
    state.taskDefinitionKey = flowInfo.taskDefinitionKey
  }
}

const actions = {
  openApproval({ commit }, flowInfo) {
    commit('OPEN_APPROVAL', flowInfo)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
